<template>
	<div>
		<div class="img-top flex-row">
			<div class="text">停电信息</div>
			<div class="title-img"></div>
		</div>
		<div class="content">
			<div class="dingdian-item flex-row">
				<div class="card" v-for="(item,i) in list" :key="i" @click="cli(item.id)">
					<div class="time">{{item.addTime}}</div>
					<div class="flex-row items-center" style="display: flex;align-items: center;">
						<i class="el-icon-bell" style="font-size: 20px;margin: 0 10px 0 20px;font-weight: 600;" />
						<span class="text-title">{{item.title}}</span>
					</div>
					<div class="text-detail" v-html="item.conment"></div>
				</div>	
			</div>
		</div>
	</div>
</template>

<script>
	import {newsListApi} from '../../http/api/ordinary.js'
	export default{
		data(){
			return{
				list: [],
				query: {
					type: 2
				}
			}
		},
		created() {
			this.init()
		},
		methods:{
			init(){
				newsListApi(this.query).then(res => {
					this.list = res
				})
			},
			cli(id){
				 this.$router.push({
					 path: '/ordinaryUser/blackoutdetail',
					 query: {
						 id: id
					 }
				 })
			}
		}
}
</script>

<style scoped>
	.img-top{
		height: 1.6rem;
		padding-left: 2rem;
		background: rgba(0, 0, 0, 0.42) url('../../assets/image/tingdian.png') no-repeat;
		background-size: cover;
		 -webkit-box-sizing: border-box;
		 display: flex;
		 align-items: center;
	}
	.text{
		font-size: 0.30rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 0.42rem;
		font-style: italic;
		letter-spacing: .03rem;
	}
	.title-img{
		width: .21rem;
		height: .29rem;
		margin: .08rem 0 0 .09rem;
		background: url('../../assets/image/share_1.png') no-repeat center center/ 100% 100%;
	}
	.content{
		background-color: #F5F5F5;
	}
	.dingdian-item{
		width: 15.33rem;
		margin: 0 auto;
		padding-bottom: 6.46rem;
		overflow: hidden;
		flex-wrap: wrap;
	}
	.card{
		 -webkit-box-sizing: border-box;
		width: 4.99rem;
		height: 2.07rem;
		margin: 0.33rem 0.06rem 0;
		background-color: #FFFFFF;
		border-radius: 0.06rem;
	}
	.card a{
		text-decoration: none;
	}
	.time{
		height: 0.58rem;
		padding-left: 0.26rem;
		margin-bottom: 0.27rem;
		font-size: 0.16rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 0.58rem;
		background-color: #FFFFFF  ;
		border-bottom: .01rem solid #F0F0F0;
		border-radius: 0.06rem 0.06rem 0 0;
	}
	.img-icon{
		width: 0.18rem;
		height: 0.18rem;
		margin:0 0.12rem 0 0.19rem;
	}
	.text-title{
		font-size: 0.16rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
		line-height: 0.22rem;
	}
	.text-detail{
		margin:0.22rem 0 0 0.19rem;
		font-size: 0.16rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 400;
		color: #727272;
		line-height: 0.22rem;
	}
</style>